<template>
  <div class="x_modal">
    <div class="x_modal_container">

      <div class="x_modal_top">
        <div class="back" @click="back">
          <svg width="27" height="28" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="13.343" cy="13.9431" r="13.2501" transform="rotate(179.597 13.343 13.9431)" fill="#252525"/>
            <path d="M14.9067 10.2221L11.7491 13.4245L14.9514 16.582" stroke="white" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="heading">X Integration</div>
        <span @click="unlinkX" class="unlink">Unlink</span>
      </div>

      <div class="x_user_info">
        <div class="x_image">
          <img v-if="user.avatar" class="avatar" :src="user.avatar" alt="avatar"/>
          <img v-else class="avatar" src="@assets/images/user-default.png" alt="avatar"/>
        </div>
        <div class="x_nickname">@{{ user.x_nickname }}</div>
      </div>

      <div class="x_settings">
        <div class="x_setting_block">
          <div class="x_setting">
            <span>Autotweets</span>
            <label class="switch">
              <input v-model="x_autotweet" type="checkbox" @change="changeXOption('x_autotweet')">
              <span class="slider round"></span>
            </label>
          </div>
        </div>

        <div class="x_setting_block">
          <div class="x_setting">
            <span>Hide Customer’s Username</span>
            <label class="switch">
              <input v-model="x_is_nickname_hidden" type="checkbox" @change="changeXOption('x_is_nickname_hidden')">
              <span class="slider round"></span>
            </label>
          </div>
          <div class="x_setting">
            <span>Include Image</span>
            <label class="switch">
              <input v-model="x_include_images" type="checkbox" @change="changeXOption('x_include_images')">
              <span class="slider round"></span>
            </label>
          </div>
        </div>

        <div class="x_setting_block price">
          <div class="x_setting">
            <span>Minimum amount</span>
            <label class="switch">
              <input v-model="x_has_min_amount" type="checkbox" @change="changeXOption('x_has_min_amount')">
              <span class="slider round"></span>
            </label>
          </div>
          <div v-if="x_has_min_amount" class="x_price_input">
            <input v-model="x_min_amount" type="number" placeholder="$ 0.00" @input="changeMinAmount">
          </div>
        </div>
      </div>

      <div class="x_preview">
        <div class="x_preview_top">
          <div class="x_preview_left">
            <div class="x_preview_user_image">
              <img v-if="user.avatar" class="avatar" :src="user.avatar" alt="avatar"/>
              <img v-else class="avatar" src="@assets/images/user-default.png" alt="avatar"/>
            </div>
            <div class="x_preview_user_info">
              <div class="x_preview_name">{{ user.name }}</div>
              <div class="x_preview_nickname">@{{ user.x_nickname }}</div>
            </div>
          </div>
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M23.6402 11.62C23.6402 19.18 19.3202 24.58 11.7602 24.58C7.4402 24.58 5.7086 22.3252 4.2002 20.26M4.20029 20.2602C4.23509 20.2542 7.44029 19.1802 7.44029 19.1802C3.83309 15.5334 3.55949 10.1322 6.36029 6.22021C7.68869 8.69102 10.1691 10.971 12.8403 11.6202C12.9435 8.50022 15.0591 6.22021 18.2403 6.22021C20.4063 6.22021 21.6807 7.04581 22.5603 8.38021H25.8003L23.6403 11.6202" fill="#00AFF0"/>
            <path d="M24.5402 11.62C24.5402 11.123 24.1373 10.72 23.6402 10.72C23.1431 10.72 22.7402 11.123 22.7402 11.62H24.5402ZM4.92698 19.7292C4.63381 19.3278 4.07075 19.2401 3.66936 19.5332C3.26797 19.8264 3.18024 20.3895 3.47341 20.7909L4.92698 19.7292ZM4.04738 19.3733C3.55755 19.4578 3.22893 19.9233 3.31338 20.4131C3.39783 20.903 3.86338 21.2316 4.35321 21.1471L4.04738 19.3733ZM7.44029 19.1802L7.72624 20.0336C8.02093 19.9348 8.24382 19.691 8.31581 19.3887C8.38781 19.0864 8.29872 18.7683 8.08015 18.5473L7.44029 19.1802ZM6.36029 6.22021L7.15299 5.79403C7.00585 5.52036 6.72796 5.34194 6.41787 5.32206C6.10779 5.30218 5.80939 5.44365 5.62851 5.69629L6.36029 6.22021ZM12.8403 11.6202L12.6277 12.4948C12.891 12.5587 13.169 12.5007 13.3847 12.3369C13.6004 12.173 13.7308 11.9207 13.7398 11.65L12.8403 11.6202ZM22.5603 8.38021L21.8089 8.87554C21.9754 9.12817 22.2577 9.28022 22.5603 9.28022V8.38021ZM25.8003 8.38021L26.5491 8.87944C26.7333 8.60327 26.7504 8.24818 26.5938 7.95554C26.4372 7.6629 26.1322 7.48021 25.8003 7.48021V8.38021ZM22.8914 11.121C22.6157 11.5346 22.7275 12.0933 23.1411 12.3691C23.5546 12.6448 24.1134 12.533 24.3891 12.1194L22.8914 11.121ZM22.7402 11.62C22.7402 15.2344 21.7083 18.2452 19.8603 20.3396C18.0247 22.4199 15.3114 23.68 11.7602 23.68V25.48C15.769 25.48 18.9957 24.0401 21.2101 21.5305C23.4121 19.0348 24.5402 15.5657 24.5402 11.62H22.7402ZM11.7602 23.68C9.77369 23.68 8.44508 23.167 7.44571 22.4598C6.41884 21.7332 5.68546 20.7676 4.92698 19.7292L3.47341 20.7909C4.22333 21.8176 5.10995 23.0121 6.40599 23.9291C7.72951 24.8657 9.4267 25.48 11.7602 25.48V23.68ZM4.35321 21.1471C4.38172 21.1422 4.40379 21.137 4.41141 21.1351C4.42179 21.1326 4.43019 21.1304 4.43523 21.1291C4.44531 21.1263 4.45352 21.124 4.45778 21.1227C4.46684 21.12 4.47509 21.1175 4.48043 21.1158C4.49191 21.1123 4.50532 21.108 4.51891 21.1036C4.54679 21.0946 4.58495 21.0821 4.63087 21.067C4.72317 21.0366 4.85227 20.9938 5.00517 20.943C5.31124 20.8412 5.71569 20.7062 6.11862 20.5716C6.52164 20.4369 6.92354 20.3024 7.22466 20.2016C7.37522 20.1512 7.50061 20.1092 7.58835 20.0798C7.63222 20.0651 7.66669 20.0535 7.69019 20.0457C7.70194 20.0417 7.71095 20.0387 7.71702 20.0367C7.72006 20.0357 7.72236 20.0349 7.72391 20.0344C7.72468 20.0341 7.72526 20.0339 7.72565 20.0338C7.72585 20.0337 7.72599 20.0337 7.72609 20.0336C7.72614 20.0336 7.72618 20.0336 7.7262 20.0336C7.72623 20.0336 7.72624 20.0336 7.44029 19.1802C7.15435 18.3268 7.15434 18.3269 7.15431 18.3269C7.15429 18.3269 7.15425 18.3269 7.1542 18.3269C7.15411 18.3269 7.15396 18.327 7.15377 18.327C7.15338 18.3272 7.1528 18.3274 7.15203 18.3276C7.1505 18.3281 7.1482 18.3289 7.14517 18.3299C7.13911 18.332 7.13012 18.335 7.11839 18.3389C7.09492 18.3468 7.06049 18.3583 7.01665 18.373C6.92898 18.4023 6.80368 18.4443 6.65322 18.4947C6.35227 18.5954 5.95069 18.7298 5.54807 18.8644C5.14535 18.999 4.74198 19.1336 4.43728 19.2349C4.2848 19.2856 4.15778 19.3277 4.06814 19.3572C4.02309 19.372 3.98882 19.3832 3.96592 19.3906C3.95412 19.3944 3.94756 19.3965 3.94487 19.3973C3.94312 19.3979 3.94574 19.3971 3.95066 19.3956C3.95286 19.395 3.95937 19.3931 3.96814 19.3907C3.97253 19.3895 3.98036 19.3875 3.99028 19.3851C3.99744 19.3834 4.01914 19.3782 4.04738 19.3733L4.35321 21.1471ZM8.08015 18.5473C4.78758 15.2186 4.54129 10.3069 7.09208 6.74414L5.62851 5.69629C2.57769 9.9575 2.8786 15.8482 6.80043 19.8131L8.08015 18.5473ZM5.5676 6.6464C6.98369 9.2803 9.64732 11.7704 12.6277 12.4948L13.0528 10.7457C10.6909 10.1716 8.3937 8.10173 7.15299 5.79403L5.5676 6.6464ZM13.7398 11.65C13.7849 10.2868 14.2659 9.15982 15.0293 8.37969C15.7879 7.60447 16.8748 7.12021 18.2403 7.12021V5.32021C16.4246 5.32021 14.8631 5.97596 13.7428 7.12074C12.6273 8.26061 11.9989 9.83365 11.9408 11.5905L13.7398 11.65ZM18.2403 7.12021C19.2071 7.12021 19.9153 7.30371 20.459 7.59382C21.0006 7.8829 21.4344 8.30744 21.8089 8.87554L23.3117 7.88489C22.8066 7.11859 22.1634 6.46313 21.3064 6.00581C20.4514 5.54952 19.4395 5.32021 18.2403 5.32021V7.12021ZM22.5603 9.28022H25.8003V7.48021H22.5603V9.28022ZM25.0514 7.88098L22.8914 11.121L24.3891 12.1194L26.5491 8.87944L25.0514 7.88098Z" fill="#00AFF0"/>
          </svg>
        </div>
        <p>“someone” just bought a gift off my wishlist worth $10.00</p>
        <p>Follow me on giftxyz at giftxyz.com/username</p>
        <div v-if="x_include_images" class="x_preview_image">
          <svg width="140" height="140" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M122.221 99.2119C122.221 112.03 111.83 122.422 99.0114 122.422H40.9873C28.1689 122.422 17.7776 112.03 17.7776 99.2119V41.1877C17.7776 28.3693 28.1689 17.978 40.9873 17.978H99.0114C111.83 17.978 122.221 28.3693 122.221 41.1877V99.2119Z" stroke="#B5B5B5" stroke-width="10.8" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M17.7776 76.0027L25.2926 68.4876C27.9162 65.864 31.4745 64.3901 35.1848 64.3901C38.8951 64.3901 42.4534 65.864 45.077 68.4876L69.9993 93.41" stroke="#B5B5B5" stroke-width="10.8" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M41.0049 122.422L77.5321 85.8943C82.9954 80.4311 91.8531 80.4311 97.3164 85.8943L120.173 108.751" stroke="#B5B5B5" stroke-width="10.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {isFlagOn} from "@/helpers/xOAuth";

export default {
  name: "XModal",
  data() {
    return {
      x_autotweet: false,
      x_is_nickname_hidden: false,
      x_include_images: true,
      x_has_min_amount: false,
      x_min_amount: 0,
      timeout: false,
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },
  mounted() {
    this.x_autotweet = isFlagOn(this.user.x_autotweet)
    this.x_is_nickname_hidden = isFlagOn(this.user.x_is_nickname_hidden)
    this.x_include_images = isFlagOn(this.user.x_include_images)
    this.x_has_min_amount = isFlagOn(this.user.x_has_min_amount)
    this.x_min_amount = this.user.x_min_amount
  },
  methods: {
    ...mapActions({
      updateUser: "auth/login",
    }),
    back() {
      this.$emit('close')
    },
    applyXUser(fields) {
      this.$store.commit('auth/SET_USER', {
        ...this.user,
        ...fields,
      })
    },
    async changeXOption(option) {
      const value = this[option]
      try {
        const { data } = await this.axios.post('change-x-option', {
          option,
          value,
        })
        if (data?.success === false) {
          throw new Error(data.message || 'Unable to update X settings')
        }
        this.applyXUser({ [option]: value })
        await this.updateUser({ force: true })
        this.toast.info(data.message)
      } catch (error) {
        this.x_autotweet = isFlagOn(this.user.x_autotweet)
        this.x_is_nickname_hidden = isFlagOn(this.user.x_is_nickname_hidden)
        this.x_include_images = isFlagOn(this.user.x_include_images)
        this.x_has_min_amount = isFlagOn(this.user.x_has_min_amount)
        this.x_min_amount = this.user.x_min_amount
        this.toast.error(error.response?.data?.message || error.message || 'Unable to update X settings')
      }
    },
    changeMinAmount() {
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.changeXOption('x_min_amount')
      }, 1000)
    },
    async unlinkX() {
      try {
        const { data } = await this.axios.post('unlink-x')
        if (data?.success === false) {
          throw new Error(data.message || 'Unable to unlink X')
        }
        this.applyXUser({
          is_x_connected: false,
          x_autotweet: false,
          x_nickname: null,
          x_id: null,
          x_is_nickname_hidden: false,
          x_include_images: false,
          x_has_min_amount: false,
          x_min_amount: null,
        })
        await this.updateUser({ force: true })
        this.$emit('close')
      } catch (error) {
        this.toast.error(error.response?.data?.message || error.message || 'Unable to unlink X')
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.x_modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 9999;
  overflow: auto;
  padding: 30px 0;
  @media (max-width: 768px) {
    padding: 30px 30px 60px;
  }

  .x_modal_container {
    margin: 0 auto;
    position: relative;
    max-width: 395px;
    width: 100%;
    text-align: center;
    padding-top: 6px;
    @media (max-width: 768px) {
      max-width: 326px;
      padding: 0;
    }

    .x_modal_top {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .back {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 26px;
        height: 26px;
        background: #252525;
        border-radius: 50%;
        cursor: pointer;
        @media (max-width: 768px) {
          width: 22px;
          height: 22px;
        }
      }

      .heading {
        color: #0B254E;
        font-size: 19.2px;
        font-weight: 700;
        line-height: 34.714px;
        @media (max-width: 768px) {
          font-size: 16px;
          line-height: 28.928px;
        }
      }

      .unlink {
        color: #F00;
        font-size: 19.2px;
        font-weight: 700;
        line-height: 34.714px;
        cursor: pointer;
        @media (max-width: 768px) {
          font-size: 16px;
          line-height: 28.928px;
        }
      }
    }

    .x_user_info {
      margin-top: 35px;
      @media (max-width: 768px) {
        margin-top: 29px;
      }

      .x_image {
        img {
          width: 92px;
          height: 92px;
          border-radius: 50%;
          object-fit: cover;
          @media (max-width: 768px) {
            width: 77px;
            height: 77px;
          }
        }
      }

      .x_nickname{
        color: #00AFF0;
        font-size: 19.526px;
        font-weight: 700;
        line-height: 34.714px;
        margin-top: 9px;
        @media (max-width: 768px) {
          font-size: 16.272px;
          line-height: 28.928px;
          margin-top: 7px;
        }
      }
    }

    .x_settings {
      display: flex;
      flex-direction: column;
      gap: 29px;
      margin-top: 19px;
      @media (max-width: 768px) {
        gap: 24px;
        margin-top: 16px;
      }

      .x_setting_block {
        display: flex;
        flex-direction: column;
        gap: 25px;
        border-radius: 9.188px 9.188px 9.192px 9.192px;
        background: #202429;
        padding: 13.782px 27.565px;
        border: 1px solid #202429;
        @media (max-width: 768px) {
          gap: 21px;
          padding: 11.485px 22.971px;
        }

        .x_setting {
          display: flex;
          align-items: center;
          justify-content: space-between;
          span {
            color: #FFF;
            font-size: 18.377px;
            font-weight: 700;
            line-height: 27.565px;
            @media (max-width: 768px) {
              font-size: 15.314px;
              line-height: 22.971px;
            }
          }

          .switch {
            position: relative;
            display: inline-block;
            width: 60px;
            height: 30px;
          }

          .switch input {
            opacity: 0;
            width: 0;
            height: 0;
          }

          .slider {
            position: absolute;
            cursor: pointer;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #ccc;
            -webkit-transition: .4s;
            transition: .4s;
          }

          .slider:before {
            position: absolute;
            content: "";
            height: 24px;
            width: 24px;
            left: 5px;
            bottom: 3px;
            background-color: white;
            -webkit-transition: .4s;
            transition: .4s;
          }

          input:checked + .slider {
            background-color: #05FF00;
          }

          input:focus + .slider {
            box-shadow: 0 0 1px #05FF00;
          }

          input:checked + .slider:before {
            -webkit-transform: translateX(26px);
            -ms-transform: translateX(26px);
            transform: translateX(26px);
          }

          .slider.round {
            border-radius: 34px;
          }

          .slider.round:before {
            border-radius: 50%;
          }
        }

        &.price {
          .x_price_input {
            margin: -13.782px -27.565px;
            background-color: #fff;
            padding: 5px 18px;
            border-radius: 0 0 9.192px 9.192px;
            text-align: left;

            input {
              color: #202429;
              font-size: 12px;
              font-weight: 500;
              line-height: 22.971px;
              opacity: 0.5;
              border: none;
            }
          }
        }
      }
    }

    .x_preview {
      border-radius: 9.192px;
      border: 2.4px solid #00AFF0;
      padding: 13px 23px 23px;
      text-align: left;
      margin-top: 29px;
      @media (max-width: 768px) {
        padding: 11px 18px 19px;
        margin-top: 24px;
      }

      .x_preview_top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;

        .x_preview_left {
          display: flex;
          gap: 10px;
          .x_preview_user_image {
            display: flex;
            img {
              width: 49px;
              height: 49px;
              border-radius: 50%;
              object-fit: cover;
            }
          }
          .x_preview_user_info {
            display: flex;
            flex-direction: column;
            justify-content: center;
            .x_preview_name {
              color: #202429;
              font-size: 14.4px;
              font-weight: 700;
              line-height: 18px;
              @media (max-width: 768px) {
                font-size: 12px;
                line-height: 16px;
              }
            }
            .x_preview_nickname {
              color: #202429;
              font-size: 14.4px;
              font-weight: 500;
              line-height: 18px;
              @media (max-width: 768px) {
                font-size: 12px;
                line-height: 16px;
              }
            }
          }
        }
      }

      p {
        color: #202429;
        font-size: 14.4px;
        font-weight: 500;
        line-height: 22.114px;
        @media (max-width: 768px) {
          font-size: 12px;
          line-height: 18.428px;
        }
      }

      .x_preview_image {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 12px;
        background: #D9D9D9;
        height: 211px;
        margin-top: 20px;
        @media (max-width: 768px) {
          height: 176px;
        }
      }
    }
  }
}
</style>
